import {
  selectLatestStatus,
  selectLatestSubjectCount,
  useCohortDefinitionStore,
} from '@verantos-dev/app-state-cohort-definition';
import { type CohortProfileView } from '@verantos-dev/data-access-cohorts';

import { useCohortDetailActions } from './useCohortDetailActions';

interface UseCohortDetailHeaderArgs {
  cohortProfile: CohortProfileView | undefined;
}

/**
 * Header view-model for the gen-3 cohort detail page. Pure TanStack +
 * Zustand, all reads from inside `gen-3/`: cohort profile comes from
 * the gen-3 `useCohortProfileQuery` (passed in via prop from the
 * orchestration hook), status from Zustand, action buttons from the
 * gen-3 `useCohortDetailActions`.
 */
export const useCohortDetailHeader = ({ cohortProfile }: UseCohortDetailHeaderArgs) => {
  const latestStatus = useCohortDefinitionStore(selectLatestStatus);
  const latestSubjectCount = useCohortDefinitionStore(selectLatestSubjectCount);
  const { actions, processError } = useCohortDetailActions();

  return {
    cohortName: cohortProfile?.cohortName ?? '',
    ownerFirstName: cohortProfile?.createdByFirstName,
    ownerLastName: cohortProfile?.createdByLastName,
    status: latestStatus,
    subjectCount: latestSubjectCount,
    lastModifiedDate: cohortProfile?.modifiedByTransactionDate,
    // The dataset this cohort was created against — fixed for its lifetime,
    // and what a reprocess uses regardless of the project's active dataset.
    datasetReleaseId: cohortProfile?.latestDatasetReleaseId,
    datasetReleaseName: cohortProfile?.latestDatasetReleaseDisplayName,
    actions,
    // TODO: cleanup with skip_process_confirmation_modal ff
    processError,
  };
};
